var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../interface/IVueDialog";
import ClientService from "../../api/ClientService";
import SystemSettingsService from '../../api/SystemSettingsService';
import { setTreeDisable } from "../../helper/util";
import RegexStr from "../../common/RegexStr";
var phoneRegex = new RegExp(RegexStr.mobile);
var AddShopDialog = (function (_super) {
    __extends(AddShopDialog, _super);
    function AddShopDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.categoryList = [];
        _this.formData = null;
        _this.groups = [];
        _this.systemSetting = '';
        _this.addtype = '';
        _this.logistic = [];
        _this.routes = [];
        _this.cleaningCompanyList = [];
        _this.financeTaxationList = [];
        _this.brandList = [];
        return _this;
    }
    AddShopDialog.prototype.created = function () {
        this.service = ClientService.getInstance();
        this.systemSettingsService = SystemSettingsService.getInstance();
        this.formData = [{
                shop_name: '',
                shop_code: '',
                shop_contact: '',
                shop_phone: '',
                business_name: this.clientDetail.business_name,
                shop_city_id: null,
                shop_address: '',
                route_name: '',
                route_id: '',
                note: '',
                shop_agent_id: '',
                logistics: '',
                logistics_sort: null,
                cleaning_company_id: null,
                finance_taxation_id: null,
                shop_brand_id: null
            }];
        this.getlogistic();
        this.getRoute();
    };
    AddShopDialog.prototype.handleLogisticsSort = function (item) {
        var sort = item.logistics_sort;
        if (sort !== '' && sort !== null && sort !== undefined) {
            sort = /^\d+$/.test(sort) ? sort : '';
            sort = sort.length > 1 ? sort.replace(/^0+/, '') : sort;
            sort = sort.length > 3 ? sort.slice(0, 3) : sort;
            this.$set(item, 'logistics_sort', sort);
            this.$forceUpdate();
        }
    };
    AddShopDialog.prototype.onlyNumbers = function (event) {
        var key = event.key;
        if (key !== 'Backspace' && !/\d/.test(key)) {
            event.preventDefault();
        }
    };
    AddShopDialog.prototype.getlogistic = function () {
        var _this = this;
        var params = {
            business_id: this.clientDetail.business_id
        };
        this.service.getLogistic(params).then(function (res) {
            _this.logistic = Array.isArray(res.data.data) ? res.data.data : [];
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    AddShopDialog.prototype.getRoute = function () {
        var _this = this;
        this.service.getRoute({ limit: 9999 }).then(function (res) {
            _this.routes = Array.isArray(res.data.data) ? res.data.data : [];
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    AddShopDialog.prototype.close = function () {
        if (this.addtype == 'addMulShop') {
            this.$emit('addShop:ok');
            this.$closeDialog();
        }
        else {
            this.$closeDialog();
        }
    };
    AddShopDialog.prototype.normalizer = function (node) {
        return {
            id: node.id,
            label: node.name,
            children: node.children,
        };
    };
    AddShopDialog.prototype.mounted = function () {
        var _this = this;
        this.service.getArea().then(function (res) {
            var data = res.data;
            if (data.success) {
                setTreeDisable(data.data);
                _this.categoryList = data.data[0].children;
            }
            else {
                _this.$message.error(data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
        this.getSupplierConfigdetail();
    };
    Object.defineProperty(AddShopDialog.prototype, "shouldShowThirdPartyFields", {
        get: function () {
            var isSortingEnabled = this.systemSetting && this.systemSetting.edi_status == 1;
            var isNotFromSupplyChain = this.clientDetail && this.clientDetail.from_system != 1;
            return isSortingEnabled && isNotFromSupplyChain;
        },
        enumerable: true,
        configurable: true
    });
    AddShopDialog.prototype.loadThirdPartyOptions = function () {
        var _this = this;
        this.service.getThirdPartyOptions().then(function (res) {
            if (res.data && res.data.success) {
                var data = res.data.data || {};
                _this.cleaningCompanyList = data.cleaning_company_list || [];
                _this.financeTaxationList = data.finance_taxation_list || [];
                _this.brandList = data.brand_list || [];
            }
        }).catch(function (err) {
            console.error('加载第三方分拣系统选项失败:', err);
        });
    };
    AddShopDialog.prototype.getSupplierConfigdetail = function () {
        var _this = this;
        this.systemSettingsService.getSupplierConfigdetail({}).then(function (res) {
            if (res.data && res.data.success) {
                _this.systemSetting = res.data.data;
                if (_this.shouldShowThirdPartyFields) {
                    _this.loadThirdPartyOptions();
                }
            }
        });
    };
    AddShopDialog.prototype.save = function () {
        var _this = this;
        if (this.addtype === 'addMulShop') {
            var isFalse_1 = false;
            this.formData.forEach(function (item, index) {
                if (item.shop_name == '') {
                    _this.$message.error('请填写门店名称');
                    isFalse_1 = true;
                    return false;
                }
                if (item.shop_city_id == null || item.shop_city_id == 0) {
                    _this.$message.error('请选择所在区域');
                    isFalse_1 = true;
                    return false;
                }
                ;
                if (item.shop_address == '') {
                    _this.$message.error('请填写门店地址');
                    isFalse_1 = true;
                    return false;
                }
                ;
                var routeRegex = /[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g;
                if (item.route_name != '' && routeRegex.test(item.route_name)) {
                    _this.$message.error('门店' + (index + 1) + '中的分拣路线格式不正确！');
                    isFalse_1 = true;
                    return false;
                }
                var rankRegex = /^(?:[1-9]\d{0,2}|0)$/;
                if (item.logistics_sort && !rankRegex.test(item.logistics_sort)) {
                    _this.$message.error('配送排序格式不正确！');
                    isFalse_1 = true;
                    return false;
                }
            });
            if (isFalse_1) {
                return;
            }
            console.log(this.formData, 888);
            var dataArr_1 = [];
            this.formData.forEach(function (item, index) {
                var idx = _this.routes.findIndex(function (e) { return e.route_name == item.route_name; });
                if (idx !== -1) {
                    item.route_id = _this.routes[idx].route_id;
                }
                else {
                    item.route_id = '';
                }
                dataArr_1.push(item);
            });
            var params = {
                supplier_to_business_id: this.clientDetail.supplier_to_business_id,
                data: JSON.stringify(dataArr_1)
            };
            this.service.addMulShop(params).then(function (res) {
                if (res.data.success) {
                    _this.$message.success('保存成功！');
                    _this.close();
                }
                else {
                    _this.$message.error(res.data.msg);
                }
                ;
            }).catch(function (err) {
                _this.$message.error(err.message);
            });
        }
        else {
            var formData = this.formData;
            if (formData[0].shop_name == '' || formData[0].shop_name == undefined) {
                this.$message.error('请填写门店名称');
                return;
            }
            ;
            if (formData[0].shop_city_id == null || formData[0].shop_city_id == 0 || formData[0].shop_city_id == undefined) {
                this.$message.error('请选择所在区域');
                return;
            }
            ;
            if (formData[0].shop_address == '' || formData[0].shop_address == undefined) {
                this.$message.error('请填写门店地址');
                return;
            }
            ;
            var routeRegex = /[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g;
            if (formData[0].route_name != '' && routeRegex.test(formData[0].route_name)) {
                this.$message.error('分拣路线格式不正确！');
                return;
            }
            var rankRegex = /^(?:[1-9]\d{0,2}|0)$/;
            if (formData[0].logistics_sort && !rankRegex.test(formData[0].logistics_sort)) {
                this.$message.error('配送排序格式不正确！');
                return;
            }
            var params = {
                supplier_to_business_id: this.clientDetail.supplier_to_business_id,
                shop_name: this.formData[0].shop_name,
                shop_code: this.formData[0].shop_code,
                shop_contact: this.formData[0].shop_contact,
                shop_phone: this.formData[0].shop_phone,
                shop_address: this.formData[0].shop_address,
                shop_city_id: this.formData[0].shop_city_id,
                note: this.formData[0].note,
                shop_agent_id: this.formData[0].shop_agent_id,
                logistics: this.formData[0].logistics,
                route_id: '',
                route_name: '',
                logistics_sort: this.formData[0].logistics_sort,
                cleaning_company_id: this.formData[0].cleaning_company_id || 0,
                finance_taxation_id: this.formData[0].finance_taxation_id || 0,
                shop_brand_id: this.formData[0].shop_brand_id || 0
            };
            var idx = this.routes.findIndex(function (item) { return item.route_name == _this.formData[0].route_name; });
            if (idx !== -1) {
                params.route_id = this.routes[idx].route_id;
            }
            else {
                params.route_name = this.formData[0].route_name;
            }
            this.service.addShop(params).then(function (res) {
                if (res.data.success) {
                    _this.$message.success('保存成功！');
                    _this.close();
                    _this.$emit('addShop:ok');
                }
                else {
                    _this.$message.error(res.data.msg);
                }
                ;
            }).catch(function (err) {
                _this.$message.error(err.message);
            });
        }
    };
    AddShopDialog.prototype.addShop = function () {
        var arr = {
            shop_name: '',
            shop_code: '',
            shop_contact: '',
            shop_phone: '',
            business_name: this.clientDetail.business_name,
            shop_city_id: null,
            shop_address: '',
            route_name: '',
            route_id: '',
            note: '',
            shop_agent_id: '',
            logistics: '',
            logistics_sort: null,
            cleaning_company_id: null,
            finance_taxation_id: null,
            shop_brand_id: null
        };
        this.formData.push(arr);
    };
    AddShopDialog = __decorate([
        Component
    ], AddShopDialog);
    return AddShopDialog;
}(VueDialog));
export default AddShopDialog;
